module.exports = __webpack_public_path__ + "img/right-indent-02.6f222f54.svg";